import React, { useEffect, useState } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import { useDispatch } from "react-redux";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { UpdateCustomersOpeningBalanceAPI } from "../../ApiRequests";
import AuthBtn from "../Buttons/AuthBtn";
import CustomerSelector from "../Selector/CustomerSelector";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";

const AddOpeningBalanceCustomerModal = ({
  Open,
  setOpen,
  initialCustomer = null,
}) => {
  const [OpeningBalance, setOpeningBalance] = useState("");
  const [SelectedCustomer, setSelectedCustomer] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!Open) return;
    setSelectedCustomer(initialCustomer || "");
    setOpeningBalance(
      initialCustomer?.opening_balance != null
        ? String(initialCustomer.opening_balance)
        : ""
    );
  }, [Open, initialCustomer]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!SelectedCustomer || OpeningBalance === "" || OpeningBalance == null) {
      WarningToast("Select customer and enter opening balance");
      setLoading(false);
      return;
    }

    try {
      const response = await UpdateCustomersOpeningBalanceAPI(
        SelectedCustomer._id,
        { amount: OpeningBalance }
      );

      if (response.data.success) {
        setOpen(false);
        SuccessToast("Opening Balance added successfully");
        dispatch(fetchCustomers());
      } else {
        ErrorToast(response.data.error?.msg);
      }
    } catch (err) {
      ErrorToast(err.response?.data?.error?.msg || "Failed to update");
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Add Opening Balance
        </h1>
        <div className="flex gap-4 max696:flex-col px-10 max696:max-h-[70vh] max696:overflow-y-auto">
          <div className="flex flex-col gap-y-4">
            <CustomerSelector
              SelectedCustomer={SelectedCustomer}
              setSelectedCustomer={setSelectedCustomer}
            />
            <AuthInput
              label="Opening Balance"
              placeholder="Enter Opening Balance"
              Value={OpeningBalance}
              setValue={setOpeningBalance}
            />
          </div>
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn title={"Save"} onSubmit={onSubmit} type={1} />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default AddOpeningBalanceCustomerModal;
